import $ from 'jquery';

class SearchM {
    constructor() {
        this.openButton = $("#open-btn");
        this.closeButton = $("#close-btn");
        this.search = $("#search");
        this.searchOpen = $(".search-open");
        this.searchField = $("#search-field");
        this.resultsDiv = $(".search-results");
        if (this.openButton) {
            this.events();
        }
        this.isSpinnerVisible = false;
        this.previousValue;
        this.typingTimer;
    }

    // events
    events() {
        this.openButton.on("click", this.openOverlay.bind(this));
        this.closeButton.on("click", this.closeOverlay.bind(this));
        this.searchField.on("keyup", this.typingLogic.bind(this));
    }

    // methods
    openOverlay() {
        this.search.addClass("search-overlay--inactive");
        this.searchOpen.addClass("search-overlay--active");
        this.searchField.focus();
    }

    closeOverlay() {
        this.searchOpen.removeClass("search-overlay--active");
        this.search.removeClass("search-overlay--inactive");
        this.searchField.val('');
        this.resultsDiv.html('');
    }

    typingLogic() {
        if (this.searchField.val() != this.previousValue) {
            clearTimeout(this.typingTimer);

            if (this.searchField.val()) {
                if (!this.isSpinnerVisible) {
                    this.resultsDiv.html('<div class="loader-blk"></div>');
                    this.isSpinnerVisible = true;
                }
                this.typingTimer = setTimeout(this.getResults.bind(this), 2000);
            } else {
                this.resultsDiv.html('');
                this.isSpinnerVisible = false;
            }
        }
        this.previousValue = this.searchField.val();
    }

    getResults() {
        $.getJSON(i6tyoneData.root_url + "/wp-json/i6tyone/v1/search/?term=" + this.searchField.val(), results => {
            if (window.innerWidth > 991) {
                this.resultsDiv.html(`
                ${results.hasMusic ? '' : "<p class='f-35-21 full-center'>검색결과가 없습니다.<br>다른 키워드로 검색해보세요!</p>"}
                ${results.albums.length ? "<div class='one-third'><h2 class='f-35-21 m-b-4 lang-en'>Album</h2><div class='search-result'>" : ''}
                ${results.albums.map(item => `
                        <a href="${item.permalink}">
                            <div class="search-result-item f-start m-b-4">
                                <img src="${item.thumbnail}" alt="thumbnail">
                                <div class="title-container">
                                    <h4 class="f-24-21">${item.title}</h4>
                                    <p class="f-13">아이자야씩스티원</p>
                                </div>
                            </div>
                        </a>`).join("")}
                ${results.albums.length ? "</div></div>" : ''}
                ${results.musics.length ? "<div class='one-third'><h2 class='f-35-21 m-b-4 lang-en'>Resource</h2><div class='search-result'>" : ''}
                ${results.musics.map(item => `
                        <a href="${item.permalink}">
                            <div class="search-result-item f-start m-b-4">
                                <img src="${item.thumbnail}" alt="thumbnail">
                                <div class="title-container">
                                    <h4 class="f-24-21">${item.title}</h4>
                                </div>
                            </div>
                        </a>`).join("")}
                ${results.musics.length ? "</div></div>" : ''}
                ${results.videos.length ? "<div class='one-third'><h2 class='f-35-21 m-b-4 lang-en'>Video</h2><div class='search-result'>" : ''}
                ${results.videos.map(item => `
                        <a href="${item.permalink}">
                            <div class="search-result-item f-start m-b-4">
                                <img src="${item.thumbnail}" alt="thumbnail">
                                <div class="title-container">
                                    <h4 class="f-24-21">${item.title}</h4>
                                </div>
                            </div>
                        </a>`).join("")}
                ${results.videos.length ? "</div></div>" : ''}

                `);
            } else {
                this.resultsDiv.html(`
                ${results.hasMusic ? '' : "<p class='f-35-21 full-center'>검색결과가 없습니다.<br>다른 키워드로 검색해보세요!</p>"}
                ${results.albums.map(item => `
                        <a href="${item.permalink}">
                            <div class="search-result-item f-start m-b-4">
                                <img src="${item.thumbnail}" alt="thumbnail">
                                <div class="title-container">
                                    <h4 class="f-24-21"><span class="lang-en">ALBUM</span> / ${item.title}</h4>
                                    <p class="f-13">아이자야씩스티원</p>
                                </div>
                            </div>
                        </a>`).join("")}
                ${results.musics.map(item => `
                        <a href="${item.permalink}">
                            <div class="search-result-item f-start m-b-4">
                                <img src="${item.thumbnail}" alt="thumbnail">
                                <div class="title-container">
                                    <h4 class="f-24-21"><span class="lang-en">MUSIC</span> / ${item.title}</h4>
                                </div>
                            </div>
                        </a>`).join("")}
                ${results.videos.map(item => `
                        <a href="${item.permalink}">
                            <div class="search-result-item f-start m-b-4">
                                <img src="${item.thumbnail}" alt="thumbnail">
                                <div class="title-container">
                                    <h4 class="f-24-21"><span class="lang-en">VIDEO</span> <br>/ ${item.title}</h4>
                                </div>
                            </div>
                        </a>`).join("")}
                ${results.hasMusic ? "</div></div>" : ''}
                
                `);
            }
            this.isSpinnerVisible = false;
        });
    }
}

export default SearchM;